import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useDataAggregation } from '../../Common/hooks/useAggregationData';
import { useCadUniqueChartsDataContext } from './hooks/useCadUniqueChartsDataContext';
import { getMonthLabel } from '../../../Common/Util/getMonthLabel'

export const AvgPeoplePerFamilyMonth = () => {
    const { chartData } = useCadUniqueChartsDataContext();

    const rawData = chartData?.avgPeoplePerFamilyMonth || [];

    const series = [
        {
            name: 'Média de Pessoas por Família',
            data: chartData?.avgPeoplePerFamilyMonth?.map(item => item.average_people_per_family) || []
        }
    ];

    const isYearComparison = rawData.length > 0 && rawData.every(item => item.mes === rawData[0].mes);
    const formattedSubtitles = isYearComparison ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`): rawData.map(item => getMonthLabel(item.mes));


    return (
        <SimpleBars
            title={'Evolução mensal das médias das pessoas por família'}
            horizontal={false}
            subtitles={formattedSubtitles}
            series={series}
            stacked
        />
    );
};